import { AmpNavigation } from '@amplify/amp-navigation/dist/index.cjs';
import React from 'react';
import PropTypes from 'prop-types';
import keycloak from '../keycloak/keycloak';
import { logUserOut } from '../user/userActions';
import { clearCDNCachedContent } from '../utils/offlineUtils';

const AmpNavigationContainer = ({
    trackLogOut,
}) => {
    const ampNavConfig = {
        _keycloak: {
            ...keycloak,
            userInfo: keycloak.tokenParsed
        },
        appName: 'mCLASS',
        focus: false,
        adultsView: false,
        logoutHandler: () => { trackLogOut().then(clearCDNCachedContent()).then(logUserOut()); }
    };
    return (
        <nav className="navbar navbar-fixed-top">
            <AmpNavigation config={ampNavConfig} />
        </nav>
    );
};

AmpNavigationContainer.propTypes = {
    trackLogOut: PropTypes.func,
};

AmpNavigationContainer.defaultProps = {
    trackLogOut: () => { },
};

export default AmpNavigationContainer;
